import React from 'react';
import {Icons, UI} from 'components';
import {store} from 'store';

export function Checkbox({ status, id }) {
  function toggle(event) {
    event.stopPropagation();
    store.dispatch({
      type: 'GOALS_TOGGLE',
      id,
    });
  }
  return (
    <UI.Checkbox checked={status == 'Completed'} onClick={toggle} circle>
      { status != 'Completed' && <Icons.Flag /> }
    </UI.Checkbox>
  );
}
